import api from './api';

export const bountyService = {
  // Admin bounty management
  getAllBounties: () => api.get('/bounty/admin/all'),
  createBounty: (bountyData) => api.post('/bounty/admin/create', bountyData),
  updateBounty: (id, bountyData) => api.put(`/bounty/admin/${id}`, bountyData),
  deleteBounty: (id) => api.delete(`/bounty/admin/${id}`),

  // User rewards
  getActiveBounties: () => api.get('/bounty/active'),
  getUserRewardStats: () => api.get('/bounty/user/stats'),
  getUserAvailableRewards: () => api.get('/bounty/user/available'),
  getUserClaimedRewards: () => api.get('/bounty/user/claimed'),
  claimReward: (bountyId) => api.post(`/bounty/user/claim/${bountyId}`),

  // Admin reward management
  getAllUserRewards: (params) => api.get('/bounty/admin/rewards', { params }),
  updateRewardStatus: (rewardIds, status) => api.put('/bounty/admin/rewards/status', { rewardIds, status }),
};
